import React from 'react';
import logo from "../../images/login_logo.jpeg";
import './index.css';

const PrintableHeader = () => {
  return (
    <div style={{background:"#fff",padding: '10px 5px 0 5px'}} className="d-flex flex-wrap align-items-center">
     <img className='print-logo' src={logo} alt="" />
      <div className='form-title flex-grow-1'>Distributor Appointment Form</div>
    </div>
  )
}

export default React.memo(PrintableHeader);